function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'ash-gray': 'rgb(216, 216, 216)','black': 'rgb(0, 0, 0)','brown-savana': 'rgb(125, 109, 94)','charcoal': 'rgb(94, 94, 94)','daisy': 'rgb(255, 184, 29)','gravel': 'rgb(194, 193, 199)','midnight': 'rgb(39, 75, 89)','military-green': 'rgb(97, 104, 86)','navy': 'rgb(28, 39, 64)','red': 'rgb(179, 0, 23)','royal-blue': 'rgb(0, 59, 166)','royal': 'rgb(0, 59, 166)','sand': 'rgb(204, 194, 167)','white': 'rgb(255, 255, 255)','heather-gray': 'rgb(216, 216, 216)','heavy-metal': 'rgb(94, 94, 94)','dark-chocolate': 'rgb(102, 85, 66)','aqua-blue': 'rgb(199, 238, 237)','bimini-blue': 'rgb(98, 167, 208)','mint-green': 'rgb(207, 233, 224)',};

    this.images = {'3-pack-combo': 'url("//dionwear.com/cdn/shop/files/swatch-war-packcombo_68x.jpg?v=11359525309638005328")','3-pack-light': 'url("//dionwear.com/cdn/shop/files/swatch-war-pack-light_68x.jpg?v=16529098618456902043")','3-pack-dark': 'url("//dionwear.com/cdn/shop/files/swatch-war-pack-dark_68x.jpg?v=9608516631979508078")','pack-combo': 'url("//dionwear.com/cdn/shop/files/swatch-dw-packcombo_68x.jpg?v=6781502271977069098")','pack-light': 'url("//dionwear.com/cdn/shop/files/swatch-dw-packlight_68x.jpg?v=11873446789656413162")','pack-dark': 'url("//dionwear.com/cdn/shop/files/swatch-dw-packdark_68x.jpg?v=8596678515972197851")','black-red': 'url("//dionwear.com/cdn/shop/files/swatch-black-red_68x.jpg?v=3123180779033217078")','black-black': 'url("//dionwear.com/cdn/shop/files/swatch-black-black1_68x.jpg?v=225282357136916754")','black-white': 'url("//dionwear.com/cdn/shop/files/swatch-black-white_68x.jpg?v=5366152372632064150")','black-gray': 'url("//dionwear.com/cdn/shop/files/swatch-black-gray_68x.jpg?v=6260674020002126433")','gray-black': 'url("//dionwear.com/cdn/shop/files/swatch-gray-black_68x.jpg?v=2543224919594849443")','gray-red': 'url("//dionwear.com/cdn/shop/files/swatch-gray-red_68x.jpg?v=13894755608595171920")','gray-gray': 'url("//dionwear.com/cdn/shop/files/swatch-gray-gray_68x.jpg?v=3951943080190240932")','gray-white': 'url("//dionwear.com/cdn/shop/files/swatch-gray-white_68x.jpg?v=17720071846021346587")','red-black': 'url("//dionwear.com/cdn/shop/files/swatch-red-black_68x.jpg?v=4311071439422168545")','red-red': 'url("//dionwear.com/cdn/shop/files/swatch-red-red_68x.jpg?v=15369761909154880994")','red-gray': 'url("//dionwear.com/cdn/shop/files/swatch-red-gray_68x.jpg?v=5278766706262606256")','red-white': 'url("//dionwear.com/cdn/shop/files/swatch-red-white_68x.jpg?v=4181607936640165956")','white-black': 'url("//dionwear.com/cdn/shop/files/swatch-white-black_68x.jpg?v=1667885501007831529")','white-red': 'url("//dionwear.com/cdn/shop/files/swatch-white-red_68x.jpg?v=13559101319190216987")','white-white': 'url("//dionwear.com/cdn/shop/files/swatch-white-white_68x.jpg?v=10895043361118384689")','military-green-black': 'url("//dionwear.com/cdn/shop/files/swatch-military-black_68x.jpg?v=8335304807586685754")','camo-black': 'url("//dionwear.com/cdn/shop/files/swatch-camo-black_68x.jpg?v=29531603743009109")','caramel-black': 'url("//dionwear.com/cdn/shop/files/swatch-caramel-black_68x.jpg?v=16892172517963465602")','heather-black': 'url("//dionwear.com/cdn/shop/files/swatch-heather-black_68x.jpg?v=2763922362803838759")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
